import {Component, ElementRef, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {FormSelectModelDto} from "../../pages/payment-link-list/models/paylinks.model";

@Component({
  selector: 'app-custom-select',
  templateUrl: './custom-select.component.html',
  styleUrls: ['./custom-select.component.scss']
})
export class CustomSelectComponent {
  @Input() isDisable = false
  @Input() positionList: string | 'top' | 'bottom' = 'bottom'
  @Input() title = ''
  @Input() itemList: FormSelectModelDto[] | undefined = []
  @Input() selectedItem: FormSelectModelDto | undefined
  @Input() size: 'input' | undefined
  @Output() selectedItemChange: EventEmitter<FormSelectModelDto> = new EventEmitter<FormSelectModelDto>()
  @Output() selectClosed: EventEmitter<void> = new EventEmitter<void>()

  isOpenSelect = false

  constructor(
    private el: ElementRef
  ) {
  }

  @HostListener('document:click', ['$event'])

  onClick(event: Event) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.close()
    }
  }


  toggleSelect() {
    if (!this.isDisable) {
      this.isOpenSelect = true
    }
  }

  setSelectedItem(item: FormSelectModelDto) {
    this.selectedItem = item
    this.selectedItemChange.emit(item)
    this.close()
  }

  close() {
    this.isOpenSelect = false
    this.selectClosed.emit()
  }
}
